import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Input } from 'reactstrap';
import ReactTable from 'react-table';
import FetchNotificationSettingsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/FetchNotificationSettingsService';
import UpdateNotificationSettingsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/UpdateNotificationSettingsService';

function NotificationSettings(props) {
    const [allNotificationSettings, setAllNotificationSettings] = useState([]);
    const [proactiveActionTypeList, setProactiveActionTypeList] = useState();
    const [selectedActions, setSelectedActions] = useState({});
    const [saving, setSaving] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activeTab, setActiveTab] = useState('new_types');
    const [changedRows, setChangedRows] = useState({});
    useEffect(() => {
        FetchNotificationSettingsService(props.token).then((res) => {
            if (res)  {
                console.log(res);
                setAllNotificationSettings(res.notificationSettingsData)
                setProactiveActionTypeList(res.proactiveActionTypeList)
            }
        });
        }, []);

        const handleFieldChange = (rowId, field, value) => {
            setChangedRows(prev => ({
                ...prev,
                [rowId]: { ...(prev[rowId] || {}), [field]: value }
            }));
        };
        
        const handleTableFieldChange = (rowIndexInFiltered, field, value) => {
            const itemToUpdate = tableData[rowIndexInFiltered];
        
            setAllNotificationSettings(prev => prev.map(item => {
                if (item.id !== itemToUpdate.id) return item;
                if (field === "problemAreaId") return { ...item, problemAreaId: value, problemAreaPathwayId: "", requestSubTypesId: "" };
                if (field === "problemAreaPathwayId") return { ...item, problemAreaPathwayId: value, requestSubTypesId: "" };
                return { ...item, [field]: value };
            }));
        
            // track cascading clears too
            const extra = field === "problemAreaId" 
                ? { problemAreaPathwayId: "", requestSubTypesId: "" } 
                : field === "problemAreaPathwayId" 
                ? { requestSubTypesId: "" } 
                : {};
        
            handleFieldChange(itemToUpdate.id, field, value);
            if (Object.keys(extra).length) {
                setChangedRows(prev => ({
                    ...prev,
                    [itemToUpdate.id]: { ...(prev[itemToUpdate.id] || {}), [field]: value, ...extra }
                }));
            }
        };

        const isRowTicket = (row) => {
            const currentActionId = selectedActions[row.id] !== undefined 
                ? selectedActions[row.id] 
                : row.action_id;
            const actionObj = proactiveActionTypeList && 
                              proactiveActionTypeList.find(a => a.id === Number(currentActionId));   
            return actionObj && actionObj.action && actionObj.action.toLowerCase() === 'ticket';
        };

        const handleActionRequired = (rowId) => {
            const current = changedRows[rowId] && changedRows[rowId].actionrequired;
            const newVal = !( current || false);
            handleFieldChange(rowId, 'actionrequired', newVal);
        };

        const handleActionChange = (value, data) => {
            setSelectedActions(prev => ({ ...prev, [data.id]: value }));
        
            const actionObj = proactiveActionTypeList && proactiveActionTypeList.find(a => a.id === Number(value));
            const actionName = actionObj ? actionObj.action.toLowerCase() : '';
        
            const isTicket = actionName === 'ticket';
            const isNotification = actionName === 'notifications';
        
            setChangedRows(prev => ({
                ...prev,
                [data.id]: {
                    ...(prev[data.id] || {}),
                    action_id: value,
                    mainRequestTypesId: isTicket ? 2 : null,
                    // clear ticket fields if not ticket
                    problemAreaId: isTicket ? (prev[data.id] && prev[data.id].problemAreaId) : null,
                    problemAreaPathwayId: isTicket ? (prev[data.id] && prev[data.id].problemAreaPathwayId) : null,
                    requestSubTypesId: isTicket ? (prev[data.id] && prev[data.id].requestSubTypesId) : null,
                    // clear actionrequired if not notification
                    actionrequired: isNotification ? (prev[data.id] && prev[data.id].actionrequired) : null,
                }
            }));
        };

        const handleSave = () => {
            setSaving(true);
            const data = {
                updatedRows: Object.keys(changedRows).map(Number),
                updatedFields: Object.values(changedRows)
            };
            UpdateNotificationSettingsService(props.token, data).then((res) => {
                if (res) {
                    setSaving(false);
                    window.location.reload();
                }
            });
        };
    const lowerSearch = searchText.toLowerCase();
    const getCurrentActionId = (item) => item.action_id;

        const filteredData =
    allNotificationSettings &&
    allNotificationSettings.filter(item => {
        const typeStr = item.notificationType || ""; 
        const typeMatch = typeStr.toLowerCase().includes(lowerSearch);
        
        const actionLabel = item.action_label || "";
        const actionMatch = actionLabel.toLowerCase().includes(lowerSearch);
        
        return typeMatch || actionMatch;
    });

    const matchesActiveTab = (item) => {
        const actionId = getCurrentActionId(item);
        if (activeTab === 'new_types') {
            return !actionId;
        }
        if (!actionId || !proactiveActionTypeList) return false;
        const action = proactiveActionTypeList.find(
            a => a.id === Number(actionId)
        );
    
        if (!action) return false;
    
        const TAB_ACTION_MAP = {
            tickets: 'ticket',
            tasks: 'task',
            notifications: 'notifications'
        };
    
        return action.action.toLowerCase() === TAB_ACTION_MAP[activeTab];
    };
    const tableData = filteredData.filter(matchesActiveTab);
    
    const columns = [
        {
            Header: 'Alert Types',
            accessor: 'notificationType',
            width: 250,
            Cell: cellInfo => (
                <div className="text-start">
                    <p className="m-0 comment-paragraph-Project-product-title">{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Action',
            accessor: 'action_label',
            width: 180,
            Cell: cellInfo => {
                const rowId = cellInfo.original.id;
                const currentValue = selectedActions[rowId] !== undefined 
                    ? selectedActions[rowId] 
                    : cellInfo.original.action_id;
                    
                return (
                    <div className="d-flex justify-content-center align-items-center w-100">
                        <select
                            className="form-control"
                            value={currentValue || ""}
                            onChange={(e) => handleActionChange(e.target.value, cellInfo.original)}
                        >
                            <option disabled value="">Select Action</option>
                            {proactiveActionTypeList && proactiveActionTypeList.map(action => (
                                <option key={action.id} value={action.id}>
                                    {action.action}
                                </option>
                            ))}
                        </select>
                    </div>
                );
            }
        },
        {
            Header: 'Priority',
            accessor: 'priority',
            width: 180,
            Cell: cellInfo => {
                    const rowId = cellInfo.original.id;
                    
                    const currentActionId = selectedActions[rowId] !== undefined 
                        ? selectedActions[rowId] 
                        : cellInfo.original.action_id;
    
                    const actionObj = proactiveActionTypeList && 
                        proactiveActionTypeList.find(a => a.id === Number(currentActionId));
    
                    const isNotification = actionObj && actionObj.action.toLowerCase() === "notifications";
                    const displayValue = isNotification ? "" : (cellInfo.value || "");
                return (
                <div className="d-flex justify-content-center align-items-center w-100">
                    <select
                        name="priority"
                        className="form-control"
                        value={displayValue}
                        onChange={(e) => handleTableFieldChange(cellInfo.index, "priority", e.target.value)}
                        disabled={isNotification} 
                        style={{ cursor: isNotification ? 'not-allowed' : 'pointer' }}
                    >
                        <option value="">--Select Priority--</option>
                        <option value="Critical">Critical</option>
                        <option value="Urgent">Urgent</option>
                        <option value="High">High</option>
                        <option value="Normal">Normal</option>
                        <option value="Low">Low</option>
                    </select>
                </div>
            )
        }
        },
        {
            Header: "Problem Area",
            accessor: "problemAreaId",
            Cell: ({ value, index, original }) => (
                <Input
                    type="select"
                    value={value || ""}
                    onChange={(e) => handleTableFieldChange(index, "problemAreaId", e.target.value)}
                    bsSize="sm"
                    disabled={!isRowTicket(original)}
                >
                    <option value="">Select Problem Area</option>
                    {(props.problemAreaList || []).map((pa) => (
                        <option key={pa.id} value={pa.id}>{pa.problemArea}</option>
                    ))}
                </Input>
            ),
        },
        {
            Header: "Problem Pathway",
            accessor: "problemAreaPathwayId",
            Cell: ({ original, value, index }) => {
                const pathwayOptions = original.problemAreaId 
                    ? (props.problemAreaPathwayList || []).filter(pw => String(pw.problemAreaId) === String(original.problemAreaId)) 
                    : [];
                return (
                    <Input
                        type="select"
                        value={value || ""}
                        onChange={(e) => handleTableFieldChange(index, "problemAreaPathwayId", e.target.value)}
                        bsSize="sm"
                        disabled={!isRowTicket(original) || !original.problemAreaId}
                    >
                        <option value="">Select Problem Pathway</option>
                        {pathwayOptions.map((pw) => (
                            <option key={pw.id} value={pw.id}>{pw.problemAreaPathway}</option>
                        ))}
                    </Input>
                );
            },
        },
        {
            Header: "Problem Type",
            accessor: "requestSubTypesId",
            Cell: ({ original, value, index }) => {
                const subTypeOptions = original.problemAreaPathwayId 
                    ? (props.subRequestTypesList || []).filter(st => String(st.problemAreaPathwayId) === String(original.problemAreaPathwayId)) 
                    : [];
                return (
                    <Input
                        type="select"
                        value={value || ""}
                        onChange={(e) => handleTableFieldChange(index, "requestSubTypesId", e.target.value)}
                        bsSize="sm"
                        disabled={!isRowTicket(original) || !original.problemAreaPathwayId}
                    >
                        <option value="">Select Problem Type</option>
                        {subTypeOptions.map((st) => (
                            <option key={st.id} value={st.id}>{st.requestSubTypes}</option>
                        ))}
                    </Input>
                );
            },
        },
        {
            Header: "Action Required",
            accessor: "actionrequired",
            width: 160,
            Cell: (cellInfo) => {
                const rowId = cellInfo.original.id;
                const currentActionId = selectedActions[rowId] !== undefined 
                ? selectedActions[rowId] 
                : cellInfo.original.action_id;

        const actionObj = proactiveActionTypeList && 
            proactiveActionTypeList.find(a => a.id === Number(currentActionId));

    // checkbox enabled only if action is "notifications"
            const isEnabled = actionObj && actionObj.action.toLowerCase() === "notifications";
                // use changedRows if changed, else fall back to DB value
                const isChecked = changedRows[rowId] && changedRows[rowId].actionrequired !== undefined
                ? changedRows[rowId].actionrequired
                : !!cellInfo.original.actionrequired;
                return (
                    <div className="d-flex justify-content-center w-100">
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => isEnabled && handleActionRequired(rowId)}
                            disabled={!isEnabled}
                        />
                    </div>
                );
            }
          },
    ];

    return (
        <>
            <Row className="align-items-center mb-2">
                <Col md={4}>
                    <h5 className="mb-0">Action Types</h5>
                </Col>
                <Col md={8}>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <Button
                            className="btn-background-color-Proceed-gallery btn-secondary"
                            onClick={handleSave}
                            disabled={saving || Object.keys(changedRows).length === 0}
                        >
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="mt-3 mb-3 align-items-center">
            <Col md={8}>
                    <div className="brand-tabs d-flex">
                        <div
                            className={`main-tabs ${activeTab === "new_types" ? "active" : ""}`}
                            onClick={() => setActiveTab("new_types")}
                        >
                            New Types
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "tickets" ? "active" : ""}`}
                            onClick={() => setActiveTab("tickets")}
                        >
                            Tickets
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "tasks" ? "active" : ""}`}
                            onClick={() => setActiveTab("tasks")}
                        >
                            Tasks
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "notifications" ? "active" : ""}`}
                            onClick={() => setActiveTab("notifications")}
                        >
                            Notifications
                        </div>
                        </div>
                    </Col>
                    <Col md={4} className="d-flex justify-content-end align-items-center gap-2">
                    <Input
                            type="text"
                            placeholder="Search by Alert Types or Action..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-100"
                        />
                        {searchText && (
                            <span
                                className="notifications-settings-clear-button"
                                onClick={() => setSearchText("")}
                            >
                                &times;
                            </span>
                        )}
                    </Col> 
            </Row>
            <ReactTable
                data={tableData}
                columns={columns}
                className="-fixed -highlight -striped mt-2"
                getTheadProps={() => ({
                    style: {
                        overflowY: 'hidden',
                        background: '#B1FA63',
                        color: '#243837',
                    },
                })}
               
                defaultPageSize={10}
                noDataText="No Data Found."
            />
        </>
    );
}

const mapStateToProps = state => ({
    token: state.loggedUser.token,
});

export default connect(mapStateToProps)(NotificationSettings);
